import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Sparkles, Globe, LogIn, Menu, X } from 'lucide-react';
import { styles } from './Navbar.styles';

export const Navbar: React.FC = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    return (
        <header className="main-header" style={styles.headerWrapper}>
            {/* Custom Responsive CSS for Navbar */}
            <style>{`
                @media (max-width: 991px) {
                    .main-header {
                        padding: 12px 16px !important;
                    }
                    .desktop-nav, .desktop-actions {
                        display: none !important;
                    }
                    .mobile-toggle-btn {
                        display: flex !important;
                    }
                }
                @media (min-width: 992px) {
                    .desktop-nav {
                        display: flex !important;
                    }
                    .desktop-actions {
                        display: flex !important;
                    }
                    .mobile-toggle-btn {
                        display: none !important;
                    }
                    .mobile-dropdown {
                        display: none !important;
                    }
                }
                
                .mobile-dropdown {
                    width: 100%;
                    overflow: hidden;
                    max-height: 0;
                    opacity: 0;
                    transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
                    background: #ffffff;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }
                .mobile-dropdown.open {
                    max-height: 480px;
                    opacity: 1;
                    padding-top: 16px;
                    padding-bottom: 8px;
                    border-top: 1px solid rgba(0, 0, 0, 0.05);
                    margin-top: 12px;
                }
                .mobile-nav-link {
                    color: #4B465C;
                    text-decoration: none;
                    font-size: 0.9rem;
                    font-weight: 500;
                    padding: 8px 0;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    transition: color 0.2s ease;
                }
                .mobile-nav-link:hover {
                    color: #7367F0;
                }
            `}</style>

            <div style={styles.container}>
                {/* Logo */}
                <Link to="/" style={styles.logoLink} onClick={closeMenu}>
                    <div style={styles.logoBox}>
                        G
                    </div>
                    <div>
                        <div style={styles.logoTextHeading}>
                            EduGlobal<span style={styles.logoTextHighlight}>SaaS</span>
                        </div>
                        <div style={styles.logoTextSub}>
                            Global Consultancy Platform
                        </div>
                    </div>
                </Link>

                {/* Desktop Nav Links */}
                <nav className="desktop-nav" style={styles.nav}>
                    <Link to="/" style={styles.navLink}>Home</Link>
                    <Link to="/about" style={styles.navLink}>About Us</Link>
                    <Link to="/services" style={styles.navLink}>Services</Link>
                    <Link to="/countries" style={styles.navLink}>Countries</Link>
                    <Link to="/universities" style={styles.navLink}>Universities</Link>
                    <Link to="/programs" style={styles.navLink}>Programs</Link>
                    <Link to="/smart-course-finder" style={styles.navLinkAi}>
                        <Sparkles size={14} /> AI Finder
                    </Link>
                    <Link to="/contact" style={styles.navLink}>Contact</Link>
                </nav>

                {/* Desktop Actions */}
                <div className="desktop-actions" style={styles.actionsGroup}>
                    <button
                        onClick={() => navigate('/login')}
                        style={styles.btnSignIn}
                        onMouseEnter={e => { e.currentTarget.style.background = '#F8F7FA'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
                    >
                        <LogIn size={13} />
                        Sign In
                    </button>

                    <button
                        onClick={() => navigate('/register/consultancy')}
                        style={styles.btnRegister}
                        onMouseEnter={e => { e.currentTarget.style.background = '#6456E2'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = '#7367F0'; }}
                    >
                        <Globe size={13} />
                        Register Consultancy
                    </button>
                </div>

                {/* Mobile Menu Toggle Button */}
                <button
                    className="mobile-toggle-btn"
                    onClick={toggleMenu}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: '#4B465C',
                        cursor: 'pointer',
                        padding: '4px',
                        display: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        outline: 'none'
                    }}
                >
                    {isOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {/* Mobile Dropdown Panel */}
            <div className={`mobile-dropdown ${isOpen ? 'open' : ''}`}>
                <Link to="/" style={styles.navLink} className="mobile-nav-link" onClick={closeMenu}>Home</Link>
                <Link to="/about" style={styles.navLink} className="mobile-nav-link" onClick={closeMenu}>About Us</Link>
                <Link to="/services" style={styles.navLink} className="mobile-nav-link" onClick={closeMenu}>Services</Link>
                <Link to="/countries" style={styles.navLink} className="mobile-nav-link" onClick={closeMenu}>Countries</Link>
                <Link to="/universities" style={styles.navLink} className="mobile-nav-link" onClick={closeMenu}>Universities</Link>
                <Link to="/programs" style={styles.navLink} className="mobile-nav-link" onClick={closeMenu}>Programs</Link>
                <Link to="/smart-course-finder" style={styles.navLinkAi} className="mobile-nav-link" onClick={closeMenu}>
                    <Sparkles size={14} /> AI Finder
                </Link>
                <Link to="/contact" style={styles.navLink} className="mobile-nav-link" onClick={closeMenu}>Contact</Link>
                
                {/* Actions on Mobile */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '8px' }}>
                    <button
                        onClick={() => { closeMenu(); navigate('/login'); }}
                        style={{ ...styles.btnSignIn, justifyContent: 'center', width: '100%', height: '40px' }}
                    >
                        <LogIn size={14} />
                        Sign In
                    </button>

                    <button
                        onClick={() => { closeMenu(); navigate('/register/consultancy'); }}
                        style={{ ...styles.btnRegister, justifyContent: 'center', width: '100%', height: '40px' }}
                    >
                        <Globe size={14} />
                        Register Consultancy
                    </button>
                </div>
            </div>
        </header>
    );
};

